import React from 'react'
import { useParams } from 'react-router-dom'
import { useGame } from 'data/hooks'
import { Content } from './content'

export const GameContent = (props) => {

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { game } = useGame(gameId)
    
  return <div className="game-content">
    { game && game.wpId && <Content url={game.wpId} /> }
  </div>
}